/**
 * @file: This file asks the operator about a file that already exists.
 *
 * The card is the shared dialog element, so the browser owns the top layer, the
 * dimmed page, the focus trap and the Escape key. Every dialog of the app reads
 * the same element, and this component builds no backdrop of its own.
 *
 * The drop zone owns the upload and the state of the question. This component
 * only shows the conflicts and reports the answer. A close that the drop zone
 * did not ask for is a cancel, because the upload waits for an answer. The
 * template tells the dialog directive that, and this component needs no
 * controller.
 */

import './asset-upload.component.less'

export default {
  template: require('./asset-upload-conflict-modal.component.html').default,
  bindings: {
    conflicts: '<',
    showConflictModal: '<',
    confirmReplace: '&',
    cancelUpload: '&',
    getOrientationText: '&'
  }
}
